<template>
    <a
        href="javascript:void(0)"
        title="Filtrar"
        class="border border-primary rounded-3xl text-primary bg-white p-2 flex items-center my-6 w-[5rem] text-right justify-between text-sm hover:bg-gray-200 hover:underline"
        v-on:click="addClass"
    >
        <Icon class="text-primary" name="Filter" />
        Filtrar
    </a>
    <div
        class="grid modal-show fixed bg-gray-600 bg-opacity-80 top-0 left-0 items-center justify-center w-screen h-screen z-20"
        :class="{ hidden: isAddClass }"
    >
        <div class="grid rounded-2xl p-4 items-center bg-white w-[20.8rem]">
            <div>
                <div class="relative">
                    <h1 class="font-bold text-primary text-center">Filtro</h1>
                    <button
                        class="absolute top-0 right-0 font-semibold text-primary"
                        v-on:click="RemoveClass"
                    >
                        x
                    </button>

                    <a
                        href="javascript:void(0) "
                        class="absolute top-0 left-0 text-blue-500 hover:underline text-xs"
                        :class="{ hidden: isAddClassVoltar }"
                        v-on:click="RemoveClassVoltar"
                    >
                        Voltar
                    </a>
                </div>

                <div :class="{ hidden: isAddClassPeriodoData }">
                    <p class="pt-3 font-bold">Período</p>
                    <ul class="flex flex-wrap gap-2">
                        <li class="table">
                            <a
                                href="javascript:void(0)"
                                class="border p-2 rounded-2xl table w-full text-center hover:bg-gray-300 hover:border-gray-300 transition-all cursor-pointer"
                                v-on:click="resetSetDate()"
                                >{{
                                    this.initialData.data && this.finalData.data
                                        ? `${this.initialData.data} até ${this.finalData.data}`
                                        : "Selecionar um período"
                                }}</a
                            >
                        </li>
                    </ul>
                    <div
                        class="flex flex-col gap-y-6 mt-6 max-h-[50vh] overflow-y-scroll no-scroll-bar"
                    >
                        <ExpandableRadio
                            :options="seasonWeeks"
                            title="Semana"
                            placeholder="Selecione uma semana"
                            class="max-w-[280px]"
                            :clear="resetData"
                            @updateValue="setDataByWeek($event)"
                        />
                        <ExpandableRadio
                            :options="computedContest"
                            :onChange="loadContest"
                            title="Campanha"
                            placeholder="Selecione uma campanha"
                            class="max-w-[280px]"
                            @updateValue="formFilter.campaign = $event"
                        />
                        <ExpandableRadio
                            :options="categories"
                            title="Categoria"
                            placeholder="Selecione uma categoria"
                            class="max-w-[280px]"
                            @updateValue="formFilter.category = $event"
                        />
                        <!-- <ExpandableCheckbox :options="regions" title="Regional" placeholder="Selecione uma ou mais regiões" class="max-w-[280px]" @updateValue="formFilter.regions = $event"/> -->
                        <ExpandableRadio
                            :options="executions"
                            title="Tipo de Execução"
                            placeholder="Selecione tipo de execução"
                            class="max-w-[280px]"
                            @updateValue="formFilter.execution = $event"
                        />
                        <ExpandableRadio
                            :options="[
                                { name: 'Aprovado', value: 'A' },
                                { name: 'Não Aprovado', value: 'R' },
                                { name: 'Pendente', value: 'N' },
                            ]"
                            title="Status"
                            placeholder="Selecione um tipo de status"
                            class="max-w-[280px]"
                            @updateValue="formFilter.status = $event"
                        />
                    </div>

                    <ul class="grid grid-cols-2 gap-7 mt-4">
                        <li>
                            <a
                                href=""
                                class="grid font-bold text-primary text-center p-2 border-primary border rounded-2xl mb-2 hover:bg-gray-300"
                            >
                                Limpar Filtros
                            </a>
                        </li>
                        <li>
                            <a
                                @click.prevent="sendSpecificFilter"
                                class="cursor-pointer grid font-bold text-center p-2 border-primary border rounded-2xl mb-2 bg-primary text-white hover:bg--black hover:border-black"
                            >
                                Aplicar Filtros
                            </a>
                        </li>
                    </ul>
                </div>

                <div :class="{ hidden: isAddClassVoltar }">
                    <p class="text-gray-500 font-bold mt-1">Data</p>
                    <ul class="grid gap-5 mt-1 grid-flow-col">
                        <li>
                            <label class="mb-1 mr-5 flex font-semibold">
                                De:
                            </label>
                            <input
                                @click="setInput('initialData')"
                                v-model="initialData.data"
                                @keyup="formatDate"
                                type="text"
                                placeholder="DD/MM/AAAA"
                                class="form-input border rounded-2xl w-full focus:border-primary disabled:opacity-50 bg-gray-100 border-gray-300"
                            />
                        </li>

                        <li>
                            <label class="mb-1 mr-5 flex font-semibold">
                                Até:
                            </label>
                            <input
                                @click="setInput('finalData')"
                                v-model="finalData.data"
                                @keyup="formatDate"
                                type="text"
                                placeholder="DD/MM/AAAA"
                                class="form-input border rounded-2xl w-full focus:border-primary disabled:opacity-50 bg-gray-100 border-300"
                            />
                        </li>
                    </ul>

                    <div class="calendar bg-gray-100 p-4 mt-8 rounded-2xl">
                        <div
                            class="header grid grid-cols-3 justify-items-center"
                        >
                            <button
                                @click="prev"
                                class="font-bold text-primary text-center"
                            >
                                &lt;
                            </button>
                            <span class="font-bold text-primary text-center">{{
                                title
                            }}</span>
                            <button
                                @click="next"
                                class="font-bold text-primary text-center"
                            >
                                &gt;
                            </button>
                        </div>

                        <div
                            class="week grid grid-flow-col justify-items-center pt-2 pb-2"
                        >
                            <div class="day text-xs uppercase">Dom</div>
                            <div class="day text-xs uppercase">Seg</div>
                            <div class="day text-xs uppercase">Ter</div>
                            <div class="day text-xs uppercase">Qua</div>
                            <div class="day text-xs uppercase">Qui</div>
                            <div class="day text-xs uppercase">Sex</div>
                            <div class="day text-xs uppercase">Sab</div>
                        </div>

                        <div
                            class="week grid grid-cols-auto-calendar justify-items-center h-8 items-center text-sm"
                            v-for="(week, key) in weeks"
                            :key="key"
                        >
                            <!-- :class="day == '0' ? 'hide' : ''" -->
                            <div
                                class="day selectable g cursor-pointer hover:bg-primary hover:text-white rounded-full p-2 py-1.5 min-w-[32px] text-center"
                                :class="{ hide: isZero(day) }"
                                v-for="(day, key) in week"
                                :key="key"
                                @click="setData(day, month, year, $event)"
                            >
                                {{ day }}
                            </div>
                        </div>
                    </div>

                    <div class="grid justify-items-center mt-8">
                        <a
                            @click="saveSpecificFilter()"
                            href="javascript:void(0)"
                            class="font-semibold grid p-4 leading-normal bg-primary text-white rounded-2xl"
                            >Selecionar Datas</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { Head } from "@inertiajs/inertia-vue3";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import { formatUpdatedDate, formatDate } from "@/Helpers/masks";
import ExpandableRadio from "@/Components/ExpandableRadio.vue";
import ExpandableCheckbox from "@/Components/ExpandableCheckbox.vue";

const DATE = new Date();
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
];
const daysInYearMonth = (y, m) => new Date(y, m + 1, 0).getDate();

export default {
    components: {
        Head,
        Head,
        Icon,
        Button,
        ExpandableRadio,
        ExpandableCheckbox,
    },

    props: {
        campaigns: Object,
        seasonWeeks: Object,
        // regions: Object,
    },

    emits: ["updateFilter"],

    data() {
        return {
            currentGallery: "",
            resetData: false,
            categories: [],
            executions: [],
            seasonWeeks: this.seasonWeeks,
            showModalChangePoints: false,
            title: "-",
            month: 0,
            year: 0,
            days: [],
            weeks: [],
            filterLessDay: "",
            initialData: {
                data: "",
                elSelected: "",
                formattedData: "",
            },
            finalData: {
                data: "",
                elSelected: "",
                formattedData: "",
            },
            currentInput: "",
            isAddClass: true,
            isAddClassVoltar: true,
            isAddClassPeriodoData: false,
            isAddClassPeriodoCalendar: false,
            showSelectRegions: false,
            formFilter: this.$inertia.form({
                campaign: "",
                category: "",
                week: "",
                execution: "",
                status: "",
            }),
        };
    },

    mounted() {
        this.init();
    },

    methods: {
        handleName(contest) {
            return `${contest.name} (${moment(contest.startDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()} à ${moment(contest.endDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()})`;
        },
        setDataByWeek(data) {
            this.resetData = false;
            this.initialData.data = data.start;
            this.initialData.formattedData = data.startFormatted;

            this.finalData.data = data.end;
            this.finalData.formattedData = data.endFormatted;
        },
        resetSetDate() {
            this.resetData = true;
            this.isAddClassPeriodoData = true;
            this.isAddClassVoltar = false;
            this.filterLessDay = "";

            if (this.initialData.elSelected) {
                this.initialData.elSelected?.classList.remove("bg-primary");
                this.initialData.elSelected?.classList.remove("text-white");
            }
            if (this.finalData.elSelected) {
                this.finalData.elSelected?.classList.remove("bg-primary");
                this.finalData.elSelected?.classList.remove("text-white");
            }

            this.initialData.data = "";
            this.initialData.elSelected = "";
            this.finalData.data = "";
            this.finalData.elSelected = "";
        },
        addClass: function () {
            this.isAddClass = false;
        },

        addClassVoltar: function () {
            this.isAddClassVoltar = false;
            this.isAddClassPeriodoData = true;
        },

        RemoveClassVoltar: function () {
            this.isAddClassVoltar = true;
            this.isAddClassPeriodoData = false;
        },

        RemoveClass: function () {
            this.isAddClass = true;
            this.isAddClassVoltar = true;
            this.isAddClassPeriodoData = false;
        },

        isZero(value) {
            if (value == 0) {
                return true;
            }
        },
        getData(day, month, year) {
            if (day < 10) {
                day = `0${day.toString()}`;
            }
            if (month + 1 < 10) {
                month = `0${(month + 1).toString()}`;
            } else {
                month = month + 1;
            }
            return `${day}${month}${year}`;
        },

        setInput(input) {
            this.currentInput = input;
        },

        setData(day, month, year, el) {
            let data = this.formatData(this.getData(day, month, year));

            if (this.currentInput == "initialData") {
                if (this.initialData.elSelected) {
                    this.initialData.elSelected.classList.remove("bg-primary");
                    this.initialData.elSelected.classList.remove("text-white");
                }
                this.initialData.elSelected = el.target;
                this.initialData.elSelected.classList.add("bg-primary");
                this.initialData.elSelected.classList.add("text-white");

                this.initialData.data = data;
            }
            if (this.currentInput == "finalData") {
                if (this.finalData.elSelected) {
                    this.finalData.elSelected.classList.remove("bg-primary");
                    this.initialData.elSelected.classList.remove("text-white");
                }
                this.finalData.elSelected = el.target;
                this.finalData.elSelected.classList.add("bg-primary");
                this.initialData.elSelected.classList.add("text-white");

                this.finalData.data = data;
            }
        },

        formatData(data) {
            let value = data;

            value = value.replace(/\D/g, "");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");

            value = value.replace(/(\d{2})(\d{2})$/, "$1$2");

            return value.substr(0, 10);
        },

        next() {
            this.update(new Date(this.year, this.month + 1, 1));
        },
        prev() {
            this.update(new Date(this.year, this.month - 1, 1));
        },
        daysInMonth() {
            return daysInYearMonth(this.year, this.month);
        },
        monthStartsOn() {
            return new Date(this.year, this.month, 1).getDay();
        },
        setTitle() {
            this.title = `${MONTHS[this.month]} ${this.year}`;
        },
        update(date) {
            if (date) {
                this.month = date.getMonth();
                this.year = date.getFullYear();
                this.day = date.getDate();
            }
            this.setTitle();
            this.setDays();
            this.setWeeks();
        },
        setDays() {
            let preDays =
                this.monthStartsOn() > 0
                    ? Array(this.monthStartsOn()).fill(0)
                    : [];
            const rawDays = [...Array(this.daysInMonth()).keys()];
            this.days = [...preDays, ...rawDays.map((item) => item + 1)];
        },
        setWeeks() {
            let n = 0;
            this.weeks = [];

            while (n < this.days.length) {
                let week = [
                    ...this.days.slice(n, (n += 7)),
                    ...Array(7).fill(0),
                ].slice(0, 7);
                this.weeks.push(week);
            }
        },
        showEvents(day) {
            alert(day);
        },
        init() {
            this.update(DATE);
        },
        formatUpdatedDate,
        formatDate,

        setFilterValueLessDays(days) {
            let dateOffset = 24 * 60 * 60 * 1000 * days;
            let dataAtual = new Date();
            this.filterLessDay = days;

            let initialDate = new Date(dataAtual.getTime() - dateOffset);

            this.initialData.data = `${initialDate.getDate()}/${
                initialDate.getMonth() + 1
            }/${initialDate.getFullYear()}`;
            this.finalData.data = `${dataAtual.getDate()}/${
                dataAtual.getMonth() + 1
            }/${dataAtual.getFullYear()}`;
        },
        formatFilterDate(data) {
            let dia = data.getDate();
            let mes = data.getMonth();
            let ano = data.getFullYear();

            return `${ano}-${mes + 1}-${dia}`;
        },

        saveSpecificFilter() {
            let initialArrayData = this.initialData.data.split("/");
            let objectInitialData = new Date(
                initialArrayData[2],
                initialArrayData[1] - 1,
                initialArrayData[0]
            );

            let finalArrayData = this.finalData.data.split("/");
            let objectFinalData = new Date(
                finalArrayData[2],
                finalArrayData[1] - 1,
                finalArrayData[0]
            );

            if (
                this.checarData(objectInitialData) &&
                this.checarData(objectFinalData)
            ) {
                let initialDateFormatted =
                    this.formatFilterDate(objectInitialData);
                let finalDataFormatted = this.formatFilterDate(objectFinalData);

                this.initialData.formattedData = initialDateFormatted;
                this.finalData.formattedData = finalDataFormatted;

                this.RemoveClassVoltar();
            }
        },
        sendSpecificFilter() {
            this.$emit("updateFilter", {
                dataInicial: this.initialData.formattedData,
                dataFinal: this.finalData.formattedData,
                campaign: this.formFilter.campaign.id,
                category: this.formFilter.category.id,
                execution: this.formFilter.execution.id,
                status: this.formFilter.status.value,
            });
            this.RemoveClass();
        },
        checarData(data) {
            return data instanceof Date && !isNaN(data);
        },
        loadContest(contest) {
            axios
                .get(`/contest/${contest.id}`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.categories = data?.categories.map((item) => ({
                        name: item.description,
                        id: item.id,
                    }));
                    this.executions = data?.executionTypes.map((item) => ({
                        name: item.description,
                        id: item.id,
                        weight: item.weight,
                    }));
                });
        },
        loadPdv(pdv) {
            axios
                .get(`/pdv/${pdv.id}/users`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.form.team = [];
                    this.users = data;

                    for (let i = 0; i < Object.keys(this.$refs).length; i++) {
                        if (this.$refs[`checkbox-` + i]) {
                            this.$refs[`checkbox-` + i].checked = false;
                        }
                    }
                });
        },
    },

    computed: {
        computedContest() {
            return this.campaigns.map((contest) => ({
                ...contest,
                name: this.handleName(contest),
                id: contest.id,
            }));
        },
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
